import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { scrollToId, WHATSAPP_URL } from "../lib/config";
import { WhatsAppIcon } from "./Icons";

export const MobileBar = () => {
  const { t, money } = useLang();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 90, opacity: 0 }} transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
          className="glass fixed inset-x-3 bottom-3 z-40 flex items-center justify-between gap-3 rounded-full border border-black/5 p-2 pl-5 shadow-[0_20px_50px_-20px_rgba(11,17,32,.4)] lg:hidden"
          data-testid="mobile-book-bar"
        >
          <div className="leading-tight">
            <span className="block text-[10px] font-semibold uppercase tracking-wider text-slate-500">{t.mobile.from}</span>
            <span className="font-display text-lg font-extrabold text-[var(--ink)]">{money(59)}</span>
          </div>
          <div className="flex items-center gap-2">
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="btn-wa h-11 w-11" aria-label="WhatsApp" data-testid="mobile-whatsapp-btn"><WhatsAppIcon className="h-5 w-5" /></a>
            <button type="button" onClick={() => scrollToId("trips")} className="btn-coral h-11 px-6 text-sm" data-testid="mobile-book-btn">{t.mobile.book}</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
